import { Component } from 'react';
import { connect } from 'react-redux';

class QaScaffold extends Component {
  render() {
    return null;
  }
}

export default connect((state) => {
  const {
    customer,
    proposal,
    financingRequest,
    financingMethod,
    eligibility,
    qaPricingGroup,
    qaBranch,
    qaSigner,
    qaSubscription,
    qaCreatedCompany,
    qaUser,
    welcomeCallResponses,
    mfaTokenResponse,
    otpTokenResponse,
    user,
  } = state;
  window.__qaScaffold = {
    customerId: `${customer?.id}`,
    proposalId: `${proposal?.id}`,
    qprId: `${proposal?.lastApprovedHomeownerRevisionId}`,
    financingRequestId: `${financingRequest?.id}`,
    financingMethodId: `${financingMethod?.id}`,
    pricingGroupId: `${qaPricingGroup?.id}`,
    coid: `${qaPricingGroup?.coid ?? qaBranch?.coid}`,
    branchId: `${qaBranch?.id}`,
    signerId: `${qaSigner?.id}`,
    signerEmail: `${qaSigner?.emailAddress}`,
    subscriptionId: `${qaSubscription?.id}`,
    subscriptionEmail: `${qaSubscription?.email}`,
    subscriptionType: `${qaSubscription?.eventType}`,
    subscriptionRole: `${qaSubscription?.role}`,
    createdCompanyId: `${qaCreatedCompany?.company?.coid}`,
    createdCompanyAdminUsername: `${qaCreatedCompany?.admin?.username}`,
    createdCompanyAdminTmpPass: `${qaCreatedCompany?.admin?.userSettingValues?.[0]?.value}`,
    createdUserId: `${qaUser?.userid}`,
    tempPassword: `${qaUser?.tempPassword}`,
    welcomeCallToken: `${welcomeCallResponses?.token}`,
    mfaToken: `${mfaTokenResponse?.secret}`,
    otpToken: `${otpTokenResponse?.token}`,
    bonitaCaseId: `${eligibility?.creditCheck?.financingProducts?.[0]?.externalId}`,
    userId: `${user?.id}`,
  };
  return {
    customer,
    proposal,
    financingRequest,
    financingMethod,
    eligibility,
    qaPricingGroup,
    qaBranch,
    qaSigner,
    qaSubscription,
    qaCreatedCompany,
    qaUser,
    welcomeCallResponses,
    mfaTokenResponse,
    otpTokenResponse,
    user,
  };
})(QaScaffold);
